import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import activity, * as _actions from "./website-data";

export const actions = _actions;

const rootReducer = combineReducers({
  activity,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
